const objeto3 = {
    titulo: `Objetos: Propiedades de tipo arreglo y objeto`,
    problemas: [
        {
            codigo: 1,
            descripcion: `Una de las características más poderosas de los objetos en JavaScript es que sus propiedades pueden ser no solo de tipos primitivos (number, string, boolean) sino que podemos definir propiedades que almacenan datos de tipo arreglo y otros objetos anidados.
Si definimos una propiedad de tipo arreglo, podemos acceder a sus elementos utilizando la notación de corchetes:
<code>
let persona1 = {
    nombre: "Diego",
    apellido: "Garcia",
    edad: 45,
    idiomas: ["Español", "Ingles", "Frances"]
}

console.log(persona1.idiomas) // ["Español", "Ingles", "Frances"]
console.log(persona1.idiomas[0]) // Español
console.log(persona1.idiomas[1]) // Ingles
console.log(persona1.idiomas[2]) // Frances
<code>`,
            programa: `let pais1 = {
  nombre: "Uruguay",
  capital: "Montevideo",
  poblacion: 3000000,
  limites: ["Argentina", "Brasil"]
}
          
console.log(pais1.limites[1])`,
            solucion: "'Brasil'"
        }, {
            codigo: 2,
            descripcion: `Si definimos atributos de tipo objeto, podemos acceder a sus propiedades utilizando la notación de punto:
<code>
const persona1 = {
    nombre: "Diego",
    apellido: "Garcia",
    edad: 45,
    idiomas: ["Español", "Ingles", "Frances"],
    trabajo: {
      empresa: "Google",
      fechaingreso: "21/12/2020",
      salario: 100000
    }
}

console.log(persona1.trabajo.empresa) // Google
</code>
persona1 es un objeto, trabajo es un objeto y empresa es un String.`,
            programa: `const computadora1 = {
  nombre: "HP",
  precio: 1000,
  componentes: {
      procesador: "i7",
      ram: "16gb",
      discoDuro: "1tb",
      monitor: {
          marca: "LG",
          tamano: "15'",
          resolucion: "1920x1080"
      }
  }
}
          
console.log(computadora1.componentes.monitor.resolucion)`,
            solucion: "'1920x1080'"
        },
        {
            codigo: 3,
            descripcion: ``,
            programa: `const empleado1 = {
    nombre: "Juan",
    apellido: "Perez",
    edad: 30,
    idiomas: ["Español"],
    trabajo: {
        empresa: "Facebook",
        fechaingreso: "01/01/2020",
        salarios: [1000, 2000, 3000]
    }
}
          
let suma = 0
for (let salario of empleado1.trabajo.salarios) {
   suma += salario
}
console.log(suma)`,
            solucion: "6000"
        }, {
            codigo: 4,
            descripcion: ``,
            programa: `const inmueble1 = {
    tipo: "Casa",
    precio: 100000,
    caracteristicas: {
        cuartos: 4,
        baños: 2,
        garage: true
    },
    ubicacion: {
        ciudad: "Córdoba",
        calle: "Colon 112"
    }
}
          
if (inmueble1.caracteristicas.garage && inmueble1.ubicacion.ciudad === "Córdoba") {
  console.log('Visitar')
} else {
  console.log('Descartar')
}`,
            solucion: "'Visitar'"
        }
    ]
}

export default objeto3;